import type { FC, ReactNode } from 'react';
import { cn } from '../lib/utils';

interface StatTileProps {
  label: string;
  value: ReactNode;
  /** A small trailing note in brand, such as `+2`. */
  note?: ReactNode;
  tone?: 'default' | 'brand';
  className?: string;
}

/** One number with an eyebrow label, for the stat rows at the top of a panel. */
export const StatTile: FC<StatTileProps> = ({
  label,
  value,
  note,
  tone = 'default',
  className
}) => (
  <div
    className={cn(
      'rounded-[10px] border border-border bg-surface-hover px-3.5 py-2.5',
      className
    )}
  >
    <p className="text-eyebrow-sm text-muted-foreground uppercase">{label}</p>
    <p
      className={cn(
        'mt-0.5 flex items-baseline gap-1.5 text-subtitle tabular-nums',
        tone === 'brand' ? 'text-brand' : 'text-foreground'
      )}
    >
      {value}
      {note ? <span className="text-caption text-brand">{note}</span> : null}
    </p>
  </div>
);
